import DeleteIcon from '@mui/icons-material/Delete'
import React from 'react'
import IconButton from './IconButton'

const DeleteButton = (props: any) => (
  <IconButton {...props}>
    <DeleteIcon fontSize='inherit' />
  </IconButton>
)

export default DeleteButton
